<template>
  <v-list-item >
    <v-list-item-content class="ma-0 pa-0">
      <v-list-item-subtitle >{{title}}</v-list-item-subtitle>
      <v-list-item-title >{{paramValue}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-icon v-if="!dimension" color="primary"></v-icon>
      {{dimension}}
    </v-list-item-action>
  </v-list-item>
  
</template>
<script>
export default {
  name: 'lineInfo',
  props: {
    title: {
      type: String,
      required: true
    },
    dimension: {
      type: String,
      required: false
    },
    paramValue: {},
    params: {
      // type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
